export { default } from './AboutCardPrimaryBenefitList';
